import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarUsuario extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            id: 0,
            nome: "",
            email: "",
            login: "",
            senha: "",
            salt: 0,
            role: "",
            ativo: "",
            restritoCentro: "",
            centroId: 0,
            centro: "",
            permissaoUsuarios: "",
            permissaoCentros: "",
            permissaoEstoque: "",
            permissaoContas: "",
            permissaoMovimentacoes: "",
            permissaoRelatorios: "",
            centroItens: []
        };

        this.changeNome = this.changeNome.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changeCentro = this.changeCentro.bind(this);
        this.changeAtivo = this.changeAtivo.bind(this);
        this.changeRestritoCentro = this.changeRestritoCentro.bind(this);
        this.changePermissaoUsuarios = this.changePermissaoUsuarios.bind(this);
        this.changePermissaoCentros = this.changePermissaoCentros.bind(this);
        this.changePermissaoEstoque = this.changePermissaoEstoque.bind(this);
        this.changePermissaoContas = this.changePermissaoContas.bind(this);
        this.changePermissaoMovimentacoes = this.changePermissaoMovimentacoes.bind(this);
        this.changePermissaoRelatorios = this.changePermissaoRelatorios.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    changeNome(e) {
        this.setState({ nome: e.target.value });
    }

    changeEmail(e) {
        this.setState({ email: e.target.value });
    }

    changeCentro(e) {
        this.setState({ centroId: e.target.value });
    }

    changeAtivo(e) {
        if (e.target.value === "ativo") this.setState({ ativo: true });
        else this.setState({ ativo: false });
    }

    changeRestritoCentro(e) {
        if (e.target.value === "sim") this.setState({ restritoCentro: true });
        else this.setState({ restritoCentro: false });
    }

    changePermissaoUsuarios(e) {
        this.setState({ permissaoUsuarios: e.target.value });
    }

    changePermissaoCentros(e) {
        this.setState({ permissaoCentros: e.target.value });
    }

    changePermissaoEstoque(e) {
        this.setState({ permissaoEstoque: e.target.value });
    }

    changePermissaoContas(e) {
        this.setState({ permissaoContas: e.target.value });
    }

    changePermissaoMovimentacoes(e) {
        this.setState({ permissaoMovimentacoes: e.target.value });
    }

    changePermissaoRelatorios(e) {
        this.setState({ permissaoRelatorios: e.target.value });
    }

    salvar() {

        this.setState({ disabled: true });

        let role = '';
        role = role += ('usuarios=' + this.state.permissaoUsuarios + ';');
        role = role += ('centros=' + this.state.permissaoCentros + ';');
        role = role += ('estoque=' + this.state.permissaoEstoque + ';');
        role = role += ('contas=' + this.state.permissaoContas + ';');
        role = role += ('movimentacoes=' + this.state.permissaoMovimentacoes + ';');
        role = role += ('relatorios=' + this.state.permissaoRelatorios);

        let filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        if (this.state.nome === "") {

            this.props.errMsgHandler("Por favor, informe o nome do usuário que será cadastrado.");
            this.setState({ disabled: false });

        } else if (this.state.email === "") {

            this.props.errMsgHandler("Por favor, informe o E-mail do usuário que será cadastrado.");
            this.setState({ disabled: false });

        } else if (!filter.test(this.state.email)) {

            this.props.errMsgHandler("Por favor, informe um E-mail válido.");
            this.setState({ disabled: false });

        } else if (this.state.centroId === "Centro") {

            this.props.errMsgHandler("Por favor, informe o centro em que o usuário a ser cadastrado pertence.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "id": this.state.id,
                "nome": this.state.nome,
                "email": this.state.email,
                "login": this.state.login,
                "senha": this.state.senha,
                "salt": this.state.salt,
                "role": role,
                "restrito_centro": this.state.restritoCentro,
                "ativo": this.state.ativo,
                "centro_id": this.state.centroId
            }

            fetch("/api/usuario/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Informações de usuário salvas com sucesso.");
                    this.props.history.push("/usuarios");

                }

            });

        }

    }

    cancelar() {

        this.props.errMsgHandler("");

        let obj = {
            id: this.props.location.state.id,
        }

        this.props.history.push({
            pathname: "/visualizarusuario",
            state: { row: obj }
        });

    }

    componentDidMount() {

        if (localStorage.roleUsuarios !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/usuarios";
        }

        this.setState({ id: this.props.location.state.id });
        this.setState({ nome: this.props.location.state.nome });
        this.setState({ email: this.props.location.state.email });
        this.setState({ login: this.props.location.state.login });
        this.setState({ senha: this.props.location.state.senha });
        this.setState({ salt: this.props.location.state.salt }); 
        this.setState({ role: this.props.location.state.role });
        this.setState({ centroId: this.props.location.state.centroId });
        this.setState({ centro: this.props.location.state.centro });
        this.setState({ permissaoUsuarios: this.props.location.state.permissaoUsuarios });
        this.setState({ permissaoCentros: this.props.location.state.permissaoCentros });
        this.setState({ permissaoEstoque: this.props.location.state.permissaoEstoque });
        this.setState({ permissaoContas: this.props.location.state.permissaoContas });
        this.setState({ permissaoMovimentacoes: this.props.location.state.permissaoMovimentacoes });
        this.setState({ permissaoRelatorios: this.props.location.state.permissaoRelatorios });

        if (this.props.location.state.ativo === 1) this.setState({ ativo: true });
        else this.setState({ ativo: false });

        if (this.props.location.state.restritoCentro === 1) this.setState({ restritoCentro: true });
        else this.setState({ restritoCentro: false });

        fetch("/api/centro/", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centroItens: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="editar-usuario-titulo">Editar Usuário</h1><br /><br />
                <form id="editar-usuario-form">
                    <input type="text"
                        placeholder="Nome"
                        value={ this.state.nome }
                        onChange={ this.changeNome } /><br />
                    <input type="text"
                        placeholder="E-mail"
                        value={ this.state.email }
                        onChange={ this.changeEmail } /><br />
                    <select value={ this.state.centroId } onChange={ this.changeCentro }>
                        <option value="Centro">Centro</option>
                        { this.state.centroItens.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select><br />
                    <ul class="edusuario-status-lst">
                        <li>
                            <b>Status: </b>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="ativo"
                                    checked={ this.state.ativo === true }
                                    onChange={ this.changeAtivo } /> Ativo
                            </label>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="inativo"
                                    checked={ this.state.ativo === false }
                                    onChange={ this.changeAtivo } /> Inativo
                            </label>
                        </li>
                    </ul>
                    <br />
                    <ul class="edusuario-status-lst">
                        <li>
                            <b>Usuário restrito ao Centro: </b>
                            <label>
                                <input type="radio"
                                    name="restrito"
                                    value="sim"
                                    checked={ this.state.restritoCentro === true }
                                    onChange={ this.changeRestritoCentro } /> Sim
                            </label>
                            <label>
                                <input type="radio"
                                    name="restrito"
                                    value="não"
                                    checked={ this.state.restritoCentro === false }
                                    onChange={ this.changeRestritoCentro } /> Não
                            </label>
                        </li>
                    </ul>
                    <br /><br /><br />
                    <p id="edusuario-permissoes-txt">
                        <b>Permissões:</b>
                    </p>
                    <br /><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Usuários: </b>
                            <label>
                                <input type="radio"
                                    name="usuarios"
                                    value="nenhuma"
                                    checked={ this.state.permissaoUsuarios === "nenhuma" }
                                    onChange={ this.changePermissaoUsuarios } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="usuarios"
                                    value="ler"
                                    checked={ this.state.permissaoUsuarios === "ler" }
                                    onChange={ this.changePermissaoUsuarios } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="usuarios"
                                    value="escrever"
                                    checked={ this.state.permissaoUsuarios === "escrever" }
                                    onChange={ this.changePermissaoUsuarios } /> Escrever
                            </label>
                        </li>
                    </ul><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Centros: </b>
                            <label>
                                <input type="radio"
                                    name="centros"
                                    value="nenhuma"
                                    checked={ this.state.permissaoCentros === "nenhuma" }
                                    onChange={ this.changePermissaoCentros } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="centros"
                                    value="ler"
                                    checked={ this.state.permissaoCentros === "ler" }
                                    onChange={ this.changePermissaoCentros } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="centros"
                                    value="escrever"
                                    checked={ this.state.permissaoCentros === "escrever" }
                                    onChange={ this.changePermissaoCentros } /> Escrever
                            </label>
                        </li>
                    </ul><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Estoque: </b>
                            <label>
                                <input type="radio"
                                    name="estoque"
                                    value="nenhuma"
                                    checked={ this.state.permissaoEstoque === "nenhuma" }
                                    onChange={ this.changePermissaoEstoque } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="estoque"
                                    value="ler"
                                    checked={ this.state.permissaoEstoque === "ler" }
                                    onChange={ this.changePermissaoEstoque } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="estoque"
                                    value="baixa"
                                    checked={ this.state.permissaoEstoque === "baixa" }
                                    onChange={ this.changePermissaoEstoque } /> Baixa
                            </label>
                            <label>
                                <input type="radio"
                                    name="estoque"
                                    value="escrever"
                                    checked={ this.state.permissaoEstoque === "escrever" }
                                    onChange={ this.changePermissaoEstoque } /> Escrever
                            </label>
                        </li>
                    </ul><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Contas: </b>
                            <label>
                                <input type="radio"
                                    name="contas"
                                    value="nenhuma"
                                    checked={ this.state.permissaoContas === "nenhuma" }
                                    onChange={ this.changePermissaoContas } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="contas"
                                    value="ler"
                                    checked={ this.state.permissaoContas === "ler" }
                                    onChange={ this.changePermissaoContas } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="contas"
                                    value="escrever"
                                    checked={ this.state.permissaoContas === "escrever" }
                                    onChange={ this.changePermissaoContas } /> Escrever
                            </label>
                        </li>
                    </ul><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Movimentações: </b>
                            <label>
                                <input type="radio"
                                    name="movimentacoes"
                                    value="nenhuma"
                                    checked={ this.state.permissaoMovimentacoes === "nenhuma" }
                                    onChange={ this.changePermissaoMovimentacoes } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="movimentacoes"
                                    value="ler"
                                    checked={ this.state.permissaoMovimentacoes === "ler" }
                                    onChange={ this.changePermissaoMovimentacoes } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="movimentacoes"
                                    value="escrever"
                                    checked={ this.state.permissaoMovimentacoes === "escrever" }
                                    onChange={ this.changePermissaoMovimentacoes } /> Escrever
                            </label>
                            <label>
                                <input type="radio"
                                    name="movimentacoes"
                                    value="corrigir"
                                    checked={ this.state.permissaoMovimentacoes === "corrigir" }
                                    onChange={ this.changePermissaoMovimentacoes } /> Corrigir
                            </label>
                        </li>
                    </ul><br />
                    <ul class="edusuario-permissoes-lst">
                        <li>
                            <b>Relatórios: </b>
                            <label>
                                <input type="radio"
                                    name="relatorios"
                                    value="nenhuma"
                                    checked={ this.state.permissaoRelatorios === "nenhuma" }
                                    onChange={ this.changePermissaoRelatorios } /> Nenhuma
                            </label>
                            <label>
                                <input type="radio"
                                    name="relatorios"
                                    value="contabilidade"
                                    checked={ this.state.permissaoRelatorios === "contabilidade" }
                                    onChange={ this.changePermissaoRelatorios } /> Contabilidade
                            </label>
                            <label>
                                <input type="radio"
                                    name="relatorios"
                                    value="ler"
                                    checked={ this.state.permissaoRelatorios === "ler" }
                                    onChange={ this.changePermissaoRelatorios } /> Ler
                            </label>
                            <label>
                                <input type="radio"
                                    name="relatorios"
                                    value="escrever"
                                    checked={ this.state.permissaoRelatorios === "escrever" }
                                    onChange={ this.changePermissaoRelatorios } /> Escrever
                            </label>
                        </li>
                    </ul>
                    <br /><br />
                    <button type="button"
                        id="edusuario-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>Salvar</button>
                    <button type="button" id="edusuario-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                </form>
            </div>
        );
    }

}

export default withRouter(EditarUsuario);

